module.exports = __webpack_public_path__ + "static/img/14.df01635.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/sp/14.png
// module id = uXIT
// module chunks = 0